import { render, staticRenderFns } from "./Finger.vue?vue&type=template&id=50b1e16c&scoped=true"
import script from "./Finger.vue?vue&type=script&lang=js"
export * from "./Finger.vue?vue&type=script&lang=js"
import style0 from "./Finger.vue?vue&type=style&index=0&id=50b1e16c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b1e16c",
  null
  
)

export default component.exports